export default function withDefault(defaultValue, field) {
  return {
    ...field,
    serialize(value, params) {
      return field.serialize(value !== null && value !== void 0 ? value : defaultValue, params);
    }
  };
}
//# sourceMappingURL=with-default.mjs.map